module.exports = {"data":{"markdownRemark":{"html":"<p>This is a test for the If This Then That service for my Blog feed.</p>","frontmatter":{"categories":["General Updates"],"date":"May 26, 2017","featuredImage":"placeholder.png","title":"Xbox One Elite Controller Review"}}},"pathContext":{"slug":"/twitter-ifttt-test/"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/post-twitter-ifttt-test.json
// module id = 445
// module chunks = 12236887540491